const SidebarMenuMixin = {
    computed: {
        isActive() {
            if (this.activePaths.length <= 0) {
                return this.$route.path.includes(this.href);
            }
            return this.activePaths.reduce((carry, path) => {
                const regex = new RegExp(path, "g");
                return carry || Boolean(this.$route.path.match(regex));
            }, false);
        },
        shouldRenderItem() {
            if (!Boolean(this.permissions) && !Boolean(this.permission)) {
                return true;
            }

            if (!Boolean(this.permissions)) {
                return Boolean(this.permission)
                    ? this.can(this.permission)
                    : true;
            }

            const shouldRender = this.permissions.reduce((state, doAction) => {
                return state || this.can(doAction);
            }, false);

            return Boolean(this.permission)
                ? shouldRender || this.can(this.permission)
                : shouldRender;
        },
    },
    props: {
        icon: {
            type: String,
            required: false,
            default: null,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        permission: {
            type: String,
            required: false,
            default: null,
        },
    },
};

export default SidebarMenuMixin;
